import { EvaluationRepository } from '../repositories/EvaluationRepository';

export class EvaluationService {
  private repository: EvaluationRepository;

  constructor() {
    this.repository = EvaluationRepository.getInstance();
  }

  /**
   * Get all available metrics
   */
  public async getMetrics(): Promise<any> {
    return await this.repository.getMetrics();
  }

  /**
   * Create a new evaluation
   */
  public async createEvaluation(payload: any): Promise<any> {
    return await this.repository.createEvaluation(payload);
  }

  /**
   * Get all evaluations
   */
  public async getAllEvaluations(): Promise<any[]> {
    return await this.repository.getAllEvaluations();
  }

  /**
   * Get evaluation by ID
   */
  public async getEvaluationById(id: string): Promise<any> {
    return await this.repository.getEvaluationById(id);
  }

  /**
   * Get models list under evaluation
   */
  public async getEvaluationModels(evaluationId: string): Promise<any> {
    return await this.repository.getEvaluationModels(evaluationId);
  }

  /**
   * Get prompt versions under selected model
   */
  public async getModelVersions(evaluationId: string, deploymentId: string): Promise<any> {
    return await this.repository.getModelVersions(evaluationId, deploymentId);
  }

  /**
   * Get results of particular evaluation run
   */
  public async getEvaluationRunResults(runId: string): Promise<any> {
    return await this.repository.getEvaluationRunResults(runId);
  }
}

// Export singleton instance
export const evaluationService = new EvaluationService();
